<template>
  <div id="kt_ecommerce_sales_table_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
    <div class="table-responsive">
      <table id="kt_datatable_example_1" class="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

          <th v-for="column in columns">{{ column.title }}</th>



        </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApiService, {EnvironmentURL} from "../../core/services/api-service";
import {APIS} from "../../core/api-urls";

export default {
  name: "datatable",
  emits: ["rowClicked"],
  props: ["url", "columns"],
  data() {
    return {
      datatable: null,
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(()=>{

      var KTDatatablesServerSide = function () {
        let columns = self.columns.map(col =>{
          return {data: col.data}
        });
        let definitions = self.columns.map(col =>{
          return col.config
        });

        // Shared variables
        let table;
        let dt;
        let filterPayment;

        // Private functions
        var initDatatable = function () {
          dt = $("#kt_datatable_example_1").DataTable({
            searchDelay: 500,
            processing: true,
            serverSide: true,
            order: [[0, 'desc']],
            stateSave: true,
            select: {
              style: 'multi',
              selector: 'td:first-child input[type="checkbox"]',
              className: 'row-selected'
            },
            ajax: {
              url: EnvironmentURL + APIS[self.url] ,
              beforeSend: function (request) {
                request.setRequestHeader("authorization", `Bearer ${self.$store.getters["Auth/token"]}`);
              }
            },
            columns: columns,
            columnDefs:definitions,
            // Add data-filter attribute
            createdRow: function (row, data, dataIndex) {
              $(row).find('a:first-child').on('click', (e) => {
                self.rowClicked(e, data);
              });
            }
          });

          table = dt.$;

          self.datatable = dt;

          // Re-init functions on every table re-draw -- more info: https://datatables.net/reference/event/draw
          dt.on('draw', function () {
            KTMenu.createInstances();
          });
        }

        // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
/*        var handleSearchDatatable = function () {
          const filterSearch = document.querySelector('[data-kt-docs-table-filter="search"]');
          filterSearch.addEventListener('keyup', function (e) {
            dt.search(e.target.value).draw();
          });
        }*/

        // Filter Datatable
/*
        var handleFilterDatatable = () => {
          // Select filter options
          filterPayment = document.querySelectorAll('[data-kt-docs-table-filter="payment_type"] [name="payment_type"]');
          const filterButton = document.querySelector('[data-kt-docs-table-filter="filter"]');

          // Filter datatable on submit
          filterButton.addEventListener('click', function () {
            // Get filter values
            let paymentValue = '';

            // Get payment value
            filterPayment.forEach(r => {
              if (r.checked) {
                paymentValue = r.value;
              }

              // Reset payment value if "All" is selected
              if (paymentValue === 'all') {
                paymentValue = '';
              }
            });

            // Filter datatable --- official docs reference: https://datatables.net/reference/api/search()
            dt.search(paymentValue).draw();
          });
        }
*/


        // Reset Filter
/*        var handleResetForm = () => {
          // Select reset button
          const resetButton = document.querySelector('[data-kt-docs-table-filter="reset"]');

          // Reset datatable
          resetButton.addEventListener('click', function () {
            // Reset payment type
            filterPayment[0].checked = true;

            // Reset datatable --- official docs reference: https://datatables.net/reference/api/search()
            dt.search('').draw();
          });
        }*/


        // Public methods
        return {
          init: function () {
            initDatatable();
  /*          handleSearchDatatable();
            handleFilterDatatable();
            handleResetForm();*/
          }
        }
      }();

      // On document ready
      KTUtil.onDOMContentLoaded(function () {
        KTDatatablesServerSide.init();
      });
    })
  },
  methods: {
    async rowClicked(event, object) {
      event.preventDefault();
      this.selectedObject = object;
      this.$emit('rowClicked', event, object)
    },
    reload(){
      this.datatable.ajax.reload();
    }
  }
}
</script>

<style scoped>

</style>
